angular.module('tgaAdmin')
  .service('assetService', ['$http', 'envService', 'domainService',
    function ($http, envService, domainService) {
      const serverAddress = envService.read('serverAddress');
      let assets = null;
      const tracks = {};
      const themes = {};

      function getAsset(assetId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}asset/${assetId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getAssets(assetType) {
        if (assetType) {
          return $http({
            method: 'GET',
            url: `${serverAddress}asset`,
            params: {
              domain: domainService.domain,
              asset_type: assetType,
            },
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        if (!assets) {
          assets = $http({
            method: 'GET',
            url: `${serverAddress}asset`,
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        return assets;
      }

      function addAsset(data) {
        // Clear assets cache
        assets = null;

        return $http({
          method: 'POST',
          url: `${serverAddress}asset`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateAsset(data) {
        // Clear assets cache
        assets = null;

        return $http({
          method: 'PUT',
          url: `${serverAddress}asset`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteAsset(assetId) {
        // Clear assets cache
        assets = null;

        return $http({
          method: 'DELETE',
          url: `${serverAddress}asset/${assetId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getBackgrounds() {
        return $http({
          method: 'GET',
          url: `${serverAddress}asset/background`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCharacters() {
        return $http({
          method: 'GET',
          url: `${serverAddress}asset/character`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getTracks(gameType) {
        if (!tracks[gameType]) {
          tracks[gameType] = $http({
            method: 'GET',
            url: `${serverAddress}asset/track`,
            params: {
              domain: domainService.domain,
              game_type: gameType,
            },
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        return tracks[gameType];
      }

      function getThemes(gameType) {
        if (!themes[gameType]) {
          themes[gameType] = $http({
            method: 'GET',
            url: `${serverAddress}asset/theme`,
            params: {
              domain: domainService.domain,
              game_type: gameType,
            },
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        return themes[gameType];
      }

      return ({
        getAsset,
        getAssets,
        addAsset,
        updateAsset,
        deleteAsset,
        getBackgrounds,
        getCharacters,
        getTracks,
        getThemes,
      });
    }]);
